/* eslint-disable react-hooks/exhaustive-deps */
import { BigDecimal } from "@pcgerente-node/pcg-comun";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Select from 'react-select';
import { clearProductosDisponibles } from "../../../../redux/actions/actionsCrear";
import { RootState, useAppDispatch } from "../../../../redux/store";
import { ChildProps_logistica_GUIA_PROFORMAviewModel } from "../ContentGuia";
import { StyleProps1, StyleProps2 } from "./styles";



const FormularioDetalles: React.FC<ChildProps_logistica_GUIA_PROFORMAviewModel> = ({vm, guia, setGuia}) => {
    const dispatch = useAppDispatch()
    const infoContenidoEstado = useSelector((state: RootState) => state.crear.ContenidoGuia)
    const contenido = infoContenidoEstado.info

    useEffect(() => {
        dispatch(clearProductosDisponibles())  
    },[])

    useEffect(() => {
        dispatch(clearProductosDisponibles())  
        vm.BuscarContenido(dispatch, guia)
    },[guia.idRemitente, guia.idDestinatario, guia.idCiudadOrigen, guia.idCiudadDestino])
  return (
    <div className="invoice-detail-items">
     <div className="table-responsive">
        <table className="table table-bordered item-table">
            <thead>
                <tr style={StyleProps2}>
                    <th style={StyleProps1}>Descripción</th>
                    <th style={StyleProps1}>Precio</th>
                    <th style={StyleProps1}>Bultos</th>
                    <th style={StyleProps1}>Cantidad</th>
                    <th style={StyleProps1}>Detalles</th>
                    <th style={StyleProps1}>Total</th>
                </tr>
            </thead>

            {
                guia.rowsContenidoParaCrear.map((child, i) => {
                    return(
                        <tbody key={i}>
                            <tr>
                                <td width={"20%"}>
                                    <Select
                                        className="basic-single"
                                        options={contenido.map(item => ({label: item.descripcion, value: item.id}))}
                                        classNamePrefix="select"
                                        name="logistica-contenido"
                                        isClearable={true}
                                        onChange={(e) => {
                                            vm.BorrarRowContenido(i,guia,setGuia)
                                            vm.handleRowContenido("descripcion", (e != null)? e.value.toString(): "", i, guia,setGuia, contenido); 
                                        } }
                                    />
                                    {/* ANTIGUO SELECT
                                        <select name="country_code"
                                        onChange={(e) => vm.handleRowContenido("descripcion", e.target.value, i, guia,setGuia, contenido)}
                                        className="form-control country_code  form-control-sm"
                                        style={StyleProps3}
                                        disabled={!contenido.length}
                                        color="white" id="payment-method-country"
                                        onKeyDown={(e) => e.key === "Delete"?vm.BorrarRowContenido(i,guia,setGuia):null}
                                        value={child.idContenido}
                                        >
                                        <option value="none" hidden>{child.descripcion || "Elija un Producto"}</option>

                                        {contenido?.map(contenido => {
                                            return (
                                            <option 
                                            key={contenido.id}
                                            value={contenido.id} 
                                            hidden={vm.rowsContenidoParaCrear.filter(el => el.idContenido === contenido.id).length>0 ||
                                                contenido.descripcion === '*SEGURO*'
                                            } // Si el contenido ya ha sido elgido no se va a mostrar para seleccionarlo de nuevo
                                            >
                                                {contenido.descripcion}
                                            </option>
                                            ) 
                                        })}
                                    </select> */}
                                </td>

                                <td className="rate" width={"10%"}>
                                    <input type="text"
                                        readOnly
                                        className="form-control form-control-sm"
                                        placeholder="Precio"
                                        value={new BigDecimal(child.precio).toFixed(2)}
                                        onChange={(e) => vm.handleRowContenido("precio", e.target.value, i,guia,setGuia)}
                                    />
                                </td>
                                <td className="text-right qty" width={"10%"}>
                                    <input type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Bultos"
                                        disabled={!child.idContenido || child.seguro}
                                        value={new BigDecimal(child.bultos).toString()}
                                        onChange={(e) => vm.handleRowContenido("bultos", e.target.value, i,guia,setGuia)}
                                        />
                                </td>

                                <td className="text-right qty" width={"10%"}>
                                    <input type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Cantidad"
                                        disabled={!child.idContenido || child.seguro}
                                        value={new BigDecimal(child.cantidad).toString()}
                                        onChange={(e) => vm.handleRowContenido("cantidad", e.target.value, i,guia,setGuia)}
                                        />
                                        
                                </td>
                                <td className="text-right qty" width={"20%"}>
                                    <input type="text"
                                        className="form-control form-control-sm"
                                        disabled={!child.idContenido}
                                        value={child.detalles||""}
                                        placeholder="Detalles"
                                        onChange={(e) => vm.handleRowContenido("detalles", e.target.value, i,guia,setGuia)}
                                        />
                                </td>
                                <td className="text-right amount"  width={"10%"}>
                                    <span className="editable-amount"/>
                                    <span className="currency">$</span> 
                                    <span className="amount">{new BigDecimal(child.total).toFixed(2)}</span>
                                </td>
                            </tr>
                        </tbody>
                    )
                })
            }
            
        </table>
    </div> 
</div> 
  );
};


export default FormularioDetalles;
